import type {ModifiableSchemaReference} from '../types';
import {getGetDataBasedSchemaModifiers} from '../functions';

export const useGetDataBasedSchemaModifier = (
  schemaRef: ModifiableSchemaReference,
) => getGetDataBasedSchemaModifiers(schemaRef);
